import * as React from "react";

//components
import { Divider, Modal, Button, Input, Spinner } from "../Atomics";
import { TextEditor } from "..";

//services
import { updateMessagetemplate } from "../../services/messagesService";
import HandleUIError from "../../utils/HandleUIError";
import { createActivityReq } from "../../services/activityLogService";

// utils (tumhara S3 upload helper)
import s3 from "../../utils/aws-config";


interface Props {
  visible: boolean;
  closeModal: () => void;
  text?: string;
  id?: number;
  isText?: boolean;
  isAudio?: boolean;
  isEmail?: boolean;
  name?: string | null;
  title?: string | null;
  editMode?: boolean;
  setEditMode: (e: boolean) => void;
  refreshTemplates: () => Promise<void>;
  filePath: string | null;
}

const TemplateContent: React.FC<Props> = ({
  id,
  visible,
  closeModal,
  text,
  name,
  editMode,
  setEditMode,
  refreshTemplates,
  isText,
  isAudio,
  isEmail,
  filePath,
  title,
}) => {
  const [newText, setNewText] = React.useState(text ? text : "");
  const [newName, setNewName] = React.useState(name ? name : "");
  const [newTitle, setNewTitle] = React.useState(title ? title : "");
  const [loading, setLoading] = React.useState(false);

  // 🆕 audio state
  const [audioFile, setAudioFile] = React.useState<File | null>(null);

  function onChangeAudio(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      setEditMode(true);
      setAudioFile(e.target.files[0]);
    }
  }

  // ----------------- FILE UPLOAD -----------------
  const handleFileUpload = async (file: File, type: string) => {
    return new Promise((resolve, reject) => {
      const params = {
        Bucket: "callguardian",
        Key: file?.name ? file?.name : type,
        Body: file,
        ContentType: file.type,
        ContentDisposition: "inline",
      };

      s3.upload(params, (err: any, data: any) => {
        if (err) {
          console.error("Error uploading file:", err);
          reject(err);
        } else {
          resolve(data.Location);
        }
      });
    });
  };

  // ----------------- SAVE -----------------
  async function unPressSave() {
    setLoading(true);
    if (id) {
      try {
        let audioUrl = filePath || ""; // pehle se jo URL save hai, fallback

        // 🆕 Agar naya audio file select hua hai to S3 pe upload karo
        if (audioFile) {
          audioUrl = (await handleFileUpload(audioFile, "audio")) as string;
          console.log("✅ Uploaded to S3:", audioUrl);
        }

        // Backend ke liye body
        const body = {
          name: newName || "",
          title: newTitle || "",
          text: newText || "",
          file: audioUrl, // 👈 URL bhejna hai
        };

        await updateMessagetemplate(id, body); // ab sirf 2 args: id & body
        await refreshTemplates();
        closeModal();
        setLoading(false);

        await createActivityReq("Pre-Stored Messages Updated Successfully");
      } catch (e) {
        setLoading(false);
        HandleUIError(e);
      }
    }
  }

  return (
    <Modal visible={visible}>
      <div className="new-staff-container">
        <div className="new-template-header d-flex justify-content-between align-items-center">
          <p className="text-light fs-5">Message Template</p>
          {editMode && (
            <Button onClick={unPressSave} className="px-4" disabled={loading}>
              {loading ? <Spinner /> : "Save"}
            </Button>
          )}
        </div>

        <div className="search-phone d-flex align-items-center mt-5 pt-5 pe-3 ps-3">
          <p className="text-light fs-5 template-name-width">Template name:</p>
          <Input
            defaultValue={name ? name : ""}
            className="mt-2 w-50 mb-2 ms-3 text-light w-100"
            onChange={(e: any) => {
              setEditMode(true);
              setNewName(e.target.value);
            }}
          />
        </div>

        {/* 🆕 Audio Case */}
        {isAudio && (
          <div className="d-flex flex-column align-items-start mx-3 mt-4 ">
            <p className="text-light fs-5 mb-2">Audio Preview:</p>

            <audio controls className="w-100 mb-3">
              <source
                src={
                  audioFile
                    ? URL.createObjectURL(audioFile) // 👈 agar naya select hua
                    : filePath || ""
                }
                type="audio/mpeg"
              />
              Your browser does not support the audio element.
            </audio>

            <input
              type="file"
              accept="audio/*"
              onChange={onChangeAudio}
              className="form-control mb-4"
            />
          </div>
        )}

        {/* Text / Email Case */}
        {!isAudio && (
          <div>
            <div className="d-flex align-items-center w-50 ms-3 w-100 pe-4">
              <p className="text-light fs-5 mb-2">
                {isText ? "Title:" : "Subject:"}
              </p>
              <Input
                defaultValue={title ? title : ""}
                className="w-100 mb-3 ms-3 text-light m-0 me-2"
                onChange={(e: any) => {
                  setEditMode(true);
                  setNewTitle(e.target.value);
                }}
              />
            </div>
            <TextEditor
              isEmail={isEmail}
              className=""
              defaultValue={text}
              onChangeText={(t: string) => {
                if (t !== text) setEditMode(true);
                setNewText(t);
              }}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TemplateContent;
